import React, { memo } from 'react';
import { Typography, Stack, CircularProgress } from 'investira.react.components';
import { validators } from 'investira.sdk';

/**
 * Renderiza o componente CardState.
 *
 * @param {Object} props - Propriedades do componente.
 * @param {*} props.loading - Propriedade `loading` do componente.
 * @param {*} props.data - Propriedade `data` do componente.
 * @param {*} props.children - Propriedade `children` do componente.
 *
 * @description
 * Este componente realiza as seguintes operacoes:
 * 1. Recebe as propriedades necessarias para compor a interface
 * 2. Organiza os estados e callbacks usados durante a renderizacao
 * 3. Renderiza a experiencia visual do organismo
 *
 * @returns {JSX.Element|null} Elemento renderizado pelo componente.
 */

const CardState = memo(props => {
  const { loading = true, data = null, children } = props;

  return (
    <>
      {loading && (
        <Stack justifyContent="center" alignItems="center" flexGrow={1} sx={{ py: 2, height: '100%' }}>
          <CircularProgress size={24} />
        </Stack>
      )}

      {!loading && validators.isEmpty(data) && (
        <Stack justifyContent="center" alignItems="center" flexGrow={1} sx={{ py: 2, height: '100%' }}>
          <Typography variant="caption" color="textSecondary">
            Nenhuma informação disponível
          </Typography>
        </Stack>
      )}

      {!loading && !validators.isEmpty(data) && children}
    </>
  );
});

CardState.displayName = 'CardState';

export default CardState;
